import directives from './module';
import {AuthenticationSvc} from '../services/AuthenticationSvc';

class WaveHeader implements ng.IComponentController {
    constructor(private $state: ng.ui.IStateService,
                public AuthenticationSvc: AuthenticationSvc) {}

    handlerClickLogin() {
        options.handHeld ? this.$state.go('wave-login') : this.AuthenticationSvc.toggleLoginModal()
    }
}

directives.component('waveHeader', {
    controller: WaveHeader,
    templateUrl: require('wave-header.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/waveHeader.ts